import { render, staticRenderFns } from "./ViewOrderChef.vue?vue&type=template&id=26c91baa&scoped=true&"
import script from "./ViewOrderChef.vue?vue&type=script&lang=js&"
export * from "./ViewOrderChef.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderChef.vue?vue&type=style&index=0&id=26c91baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c91baa",
  null
  
)

export default component.exports